"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainProvider = void 0;
const common_1 = require("@bugfender/common");
const api_client_1 = require("../api-client");
const override_console_methods_1 = require("../browser-integration/override-console-methods");
const channel_1 = require("../channel");
const connection_1 = require("../connection");
const current_session_1 = require("../current-session");
const database_1 = require("../data/database");
const table_1 = require("../data/table");
const device_keys_table_1 = require("../data/device-keys.table");
const in_memory_storage_1 = require("../data/in-memory.storage");
const issues_table_1 = require("../data/issues.table");
const logs_table_1 = require("../data/logs.table");
const sessions_table_1 = require("../data/sessions.table");
const device_1 = require("../device");
const http_client_1 = require("../http-client");
const log_factory_1 = require("../log-factory");
const logger_1 = require("../logger");
const reset_storage_1 = require("../reset-storage");
const session_factory_1 = require("../session-factory");
const storage_guard_1 = require("../storage-guard");
const storage_processor_1 = require("../storage-processor");
const storage_writer_1 = require("../storage-writer");
const storage_writer_handler_1 = require("../storage-writer.handler");
const storage_writer_hub_1 = require("../storage-writer.hub");
const utils_1 = require("../utils");
const storage_writer_worker_1 = __importDefault(require("../storage-writer.worker"));
const event_printer_1 = require("../browser-integration/event.printer");
const cache = new Map();
const Cached = (0, utils_1.CacheDecoratorFactory)(cache);
class MainProvider {
    constructor(bugfender, options, preInitProvider, sdkUserAgent, version) {
        this.bugfender = bugfender;
        this.options = options;
        this.preInitProvider = preInitProvider;
        this.sdkUserAgent = sdkUserAgent;
        this.version = version;
        this.apiFeatures = this.preInitProvider.provideAPIFeatureDetection();
        this.commandsQueue = this.preInitProvider.provideCommandsQueue();
        this.console = this.preInitProvider.provideWindow().console;
        this.operationModes = this.preInitProvider.provideOperationModes();
        this.uuidFactory = this.preInitProvider.provideUUIDFactory();
        this.window = this.preInitProvider.provideWindow();
    }
    getApiClient() {
        const httpClient = new http_client_1.HttpClient(this.options.apiURL, this.options.appKey, this.sdkUserAgent);
        return new api_client_1.ApiClient(this.options.appKey, httpClient);
    }
    getChannel() {
        return __awaiter(this, void 0, void 0, function* () {
            let channel;
            if (yield this.operationModes.isMultiTab()) {
                channel = new channel_1.Channel((0, channel_1.createBroadcastChannel)(), this.getLogger('Channel'));
            }
            else {
                channel = new channel_1.MonoChannel();
            }
            this.getCurrentSession().then((currentSession) => {
                channel.setCurrentSession(currentSession);
            });
            return channel;
        });
    }
    getConnection() {
        return new connection_1.Connection(this.window);
    }
    getCurrentSession() {
        return __awaiter(this, void 0, void 0, function* () {
            return new current_session_1.CurrentSession(this.getDevice(), this.getLogger('CurrentSession'), this.getSessionStorage(), yield this.getSessionsTable(), this.uuidFactory);
        });
    }
    getDatabase() {
        return new database_1.Database();
    }
    getDevice() {
        return new device_1.Device(this.preInitProvider.provideBrowser(), this.getLocalStorage(), this.version, this.uuidFactory);
    }
    getInitDeferred() {
        return (0, utils_1.createDeferred)();
    }
    getDeviceKeysTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new device_keys_table_1.IDBDeviceKeysTable(new table_1.Table(this.getDatabase().get(), 'devicekeys'));
            }
            else {
                return new device_keys_table_1.InMemoryDeviceKeysTable();
            }
        });
    }
    getIssuesTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new issues_table_1.IDBIssuesTable(new table_1.Table(this.getDatabase().get(), 'issues'));
            }
            else {
                return new issues_table_1.InMemoryIssuesTable();
            }
        });
    }
    getLogger(tag) {
        if (this.options.debug) {
            return new logger_1.ConsoleLogger(this.console, tag);
        }
        else {
            return new logger_1.NoopLogger();
        }
    }
    getLogsTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new logs_table_1.IDBLogsTable(new table_1.Table(this.getDatabase().get(), 'logs'), new log_factory_1.LogFactory());
            }
            else {
                return new logs_table_1.InMemoryLogsTable(new log_factory_1.LogFactory(), 3000);
            }
        });
    }
    getOverrideConsoleMethods() {
        return new override_console_methods_1.OverrideConsoleMethods(this.commandsQueue, this.window);
    }
    getPrintToConsole() {
        return new common_1.PrintToConsole(this.console);
    }
    getRegisterBrowserEventsHandler() {
        return new common_1.RegisterBrowserEventsHandler(this.bugfender, this.window);
    }
    getRegisterErrorHandler() {
        const handler = new common_1.RegisterErrorHandler(this.window);
        return handler;
    }
    getRegisterUIEventsHandler() {
        return new common_1.RegisterUIEventsHandler(this.bugfender, this.window);
    }
    getResetStorage() {
        return __awaiter(this, void 0, void 0, function* () {
            return new reset_storage_1.ResetStorage(this.apiFeatures, yield this.getCurrentSession(), this.getDatabase(), this.getLocalStorage(), this.getSessionStorage());
        });
    }
    getStorageGuard() {
        return new storage_guard_1.StorageGuard(this.getApiClient(), this.getDevice(), this.getLogger('StorageGuard'), this.options);
    }
    getStorageProcessor() {
        return __awaiter(this, void 0, void 0, function* () {
            const sessionFactory = new session_factory_1.SessionFactory(this.getDevice(), this.version, this.window);
            return new storage_processor_1.StorageProcessor(this.getApiClient(), yield this.getChannel(), this.getConnection(), this.getLogger('StorageProcessor'), this.getDevice(), yield this.getDeviceKeysTable(), yield this.getIssuesTable(), yield this.getLogsTable(), this.options, sessionFactory, yield this.getSessionsTable(), yield this.getStorageGuard());
        });
    }
    getStorageWriterHub() {
        return __awaiter(this, void 0, void 0, function* () {
            const isMultiThread = yield this.operationModes.isMultiThread();
            let handler;
            if (isMultiThread) {
                handler = new storage_writer_worker_1.default();
            }
            else {
                handler = new storage_writer_handler_1.MainThreadStorageWriterHandler(new storage_writer_1.StorageWriter(yield this.getDeviceKeysTable(), yield this.getIssuesTable(), new log_factory_1.LogFactory(), yield this.getLogsTable()));
            }
            return new storage_writer_hub_1.StorageWriterHub(yield this.getChannel(), this.getDevice(), handler, new event_printer_1.EventPrinter(this.console, this.options.printToConsole), this.options, this.getPrintToConsole(), yield this.getCurrentSession(), yield this.getStorageGuard(), this.uuidFactory, this.window);
        });
    }
    getLocalStorage() {
        if (this.apiFeatures.isLocalStorageSupported()) {
            return this.window.localStorage;
        }
        else {
            return new in_memory_storage_1.InMemoryStorage();
        }
    }
    getSessionStorage() {
        if (this.apiFeatures.isSessionStorageSupported()) {
            return this.window.sessionStorage;
        }
        else {
            return new in_memory_storage_1.InMemoryStorage();
        }
    }
    getSessionsTable() {
        return __awaiter(this, void 0, void 0, function* () {
            if (yield this.operationModes.isMultiTab()) {
                return new sessions_table_1.IDBSessionsTable(new table_1.Table(this.getDatabase().get(), 'sessions'));
            }
            else {
                return new sessions_table_1.InMemorySessionsTable();
            }
        });
    }
}
exports.MainProvider = MainProvider;
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], MainProvider.prototype, "getApiClient", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getChannel", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", connection_1.Connection)
], MainProvider.prototype, "getConnection", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getCurrentSession", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", database_1.Database)
], MainProvider.prototype, "getDatabase", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], MainProvider.prototype, "getDevice", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], MainProvider.prototype, "getInitDeferred", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getDeviceKeysTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getIssuesTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getLogsTable", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", override_console_methods_1.OverrideConsoleMethods)
], MainProvider.prototype, "getOverrideConsoleMethods", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", common_1.PrintToConsole)
], MainProvider.prototype, "getPrintToConsole", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", common_1.RegisterBrowserEventsHandler)
], MainProvider.prototype, "getRegisterBrowserEventsHandler", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", common_1.RegisterErrorHandler)
], MainProvider.prototype, "getRegisterErrorHandler", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", common_1.RegisterUIEventsHandler)
], MainProvider.prototype, "getRegisterUIEventsHandler", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getResetStorage", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], MainProvider.prototype, "getStorageGuard", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getStorageProcessor", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getStorageWriterHub", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Storage)
], MainProvider.prototype, "getLocalStorage", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Storage)
], MainProvider.prototype, "getSessionStorage", null);
__decorate([
    Cached(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MainProvider.prototype, "getSessionsTable", null);
